// Data Access Groups service — admin-only CRUD over manager-service.
//
// Endpoints (mounted at /api/manager/api/data-access-groups):
//   GET    /                       — list groups (summary)
//   POST   /                       — create
//   GET    /:groupId                — full detail (denials + member ids)
//   PUT    /:groupId                — update name/slug/description/denials
//   DELETE /:groupId                — delete (provide reassign target if members)
//   POST   /:groupId/members        — bulk add/remove user_ids

const BASE = '/api/manager/api/data-access-groups';

function authHeaders(extra = {}) {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

async function _json(response) {
  if (!response.ok) {
    let detail = `HTTP ${response.status}`;
    try {
      const body = await response.json();
      detail = body.detail || body.message || detail;
    } catch { /* no body */ }
    const err = new Error(detail);
    err.status = response.status;
    throw err;
  }
  if (response.status === 204) return null;
  return response.json();
}

export async function listGroups() {
  const r = await fetch(`${BASE}/`, { headers: authHeaders() });
  return _json(r);
}

export async function getGroup(groupId) {
  const r = await fetch(`${BASE}/${groupId}`, { headers: authHeaders() });
  return _json(r);
}

export async function createGroup({ name, slug, description, denials = [] }) {
  const r = await fetch(`${BASE}/`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ name, slug, description, denials }),
  });
  return _json(r);
}

export async function updateGroup(groupId, payload) {
  const r = await fetch(`${BASE}/${groupId}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  return _json(r);
}

export async function deleteGroup(groupId, { reassignToGroupId = null, fallbackToCustom = false } = {}) {
  const r = await fetch(`${BASE}/${groupId}`, {
    method: 'DELETE',
    headers: authHeaders(),
    body: JSON.stringify({
      reassign_to_group_id: reassignToGroupId,
      fallback_to_custom: fallbackToCustom,
    }),
  });
  return _json(r);
}

export async function setGroupMembers(groupId, { addUserIds = [], removeUserIds = [] }) {
  const r = await fetch(`${BASE}/${groupId}/members`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({
      add_user_ids: addUserIds,
      remove_user_ids: removeUserIds,
    }),
  });
  return _json(r);
}
